module.exports = __webpack_public_path__ + "static/media/ic-home-carousel-arrow.6cc30ad6.svg";